import e from "../../utils/classNames.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/selects/SelectFilter.tsx
var n = (n) => {
	let { isFilterActive: r, filterValue: i, onChange: a } = n, o = e("select-filter-input", (r || i) && "select-filter-input-active");
	return /* @__PURE__ */ t("input", {
		type: "text",
		className: o,
		autoFocus: !0,
		onChange: a,
		value: i
	});
};
//#endregion
export { n as default };

//# sourceMappingURL=SelectFilter.js.map